import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import "./Header.css";

const Header = ({ headerData, kuralData }) => {
  const [menuOpen, setMenuOpen] = useState(false);
  const [activeSubMenu, setActiveSubMenu] = useState(null);
  const [randomKural, setRandomKural] = useState(null);

  // Function to select a random Kural
  const updateRandomKural = () => {
    if (kuralData && kuralData.kural.length > 0) {
      const randomIndex = Math.floor(Math.random() * kuralData.kural.length);
      setRandomKural(kuralData.kural[randomIndex]);
    }
  };

  // Run once when component mounts & update every 30 seconds
  useEffect(() => {
    updateRandomKural(); // Set initial Kural
    const interval = setInterval(updateRandomKural, 30000); // Change every 30 seconds

    return () => clearInterval(interval); // Cleanup interval on unmount
  }, [kuralData]);

  const toggleMenu = () => setMenuOpen(!menuOpen);
  const toggleSubMenu = (index) => setActiveSubMenu(activeSubMenu === index ? null : index);
  const closeMenu = () => {
    setMenuOpen(false);
    setActiveSubMenu(null);
  };

  return (
    <header className="header">
      <div className="header-left">
        <Link to={headerData.logo.link}>
          <img src={headerData.logo.src} alt={headerData.logo.alt} className="header-logo" />
        </Link>
        <div className="header-site-info">
          

          {/* Site Name and Quote */}
          <div className="header-site-name">
            <span className="site-name">{headerData.siteName.text}</span>
            <span className="site-sub-text">{headerData.siteName.subText}</span>
          </div>
          {/* Middle Spacer */}
          <div className="header-spacer"></div>
          {/* Display Random Kural */}
          {randomKural && (
            <div className="header-kural">
              <span className="kural-adhigaram">குறள் எண்: {randomKural.Number}</span>
              <span className="kural-text">
                {randomKural.Line1}<br />{randomKural.Line2}
              </span>
              <span className="kural-explanation">{randomKural.mv}</span>
            </div>
          )}
        </div>
      </div>

      <button className="menu-toggle" onClick={toggleMenu} aria-label={menuOpen ? "Close menu" : "Open menu"}>
        {menuOpen ? (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="30" height="30" fill="#fff">
            <path d="M18.3 5.71a1 1 0 00-1.42 0L12 10.59 7.12 5.71A1 1 0 005.7 7.12L10.59 12l-4.89 4.88a1 1 0 001.41 1.41L12 13.41l4.88 4.88a1 1 0 001.41-1.41L13.41 12l4.88-4.88a1 1 0 000-1.41z"></path>
          </svg>
        ) : (
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 80" width="30" height="30" fill="#fff">
            <rect width="100" height="10"></rect>
            <rect y="30" width="100" height="10"></rect>
            <rect y="60" width="100" height="10"></rect>
          </svg>
        )}
      </button>

      <nav className={`header-nav ${menuOpen ? "active" : ""}`}>
        <ul className="menu">
          {headerData.menu.map((item, index) => (
            <li key={index} className={`menu-item ${activeSubMenu === index ? "open" : ""}`}>
              {item.link ? (
                <Link to={item.link} onClick={closeMenu}>{item.title}</Link>
              ) : (
                <>
                  <span className="menu-title" onClick={() => toggleSubMenu(index)}>{item.title}</span>
                  {item.subMenu && (
                    <ul className={`sub-menu ${activeSubMenu === index ? "open" : ""}`}>
                      {item.subMenu.map((subItem, subIndex) => (
                        <li key={subIndex}>
                          <Link to={subItem.link} onClick={closeMenu}>{subItem.title}</Link>
                        </li>
                      ))}
                    </ul>
                  )}
                </>
              )}
            </li>
          ))}
        </ul>
      </nav>
    </header>
  );
};

export default Header;
